module.exports = __webpack_public_path__ + "static/img/max_pictgrid5_800x574.79694db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid5_800x574.jpg
// module id = +M6A
// module chunks = 0